import './App.css';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Intro from './components/Intro/Intro';
import Navbar from './components/Navbar/Navbar';
import Projects from './components/Projects/Projects';
import Experiments from './components/Experiments/Experiments';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Intro />
      <Projects />
      <Experiments />
      <About />
      <Contact />
    </div>
  );
}

export default App;
